﻿import { Directive } from "@app/components/directive";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { KbService } from "@app/services/kb.service";

@NgComponent({
    token: Token.KbPageTitle,
    dependencies: [
        Token.KbService
    ]
})
export class KbPageTitle extends Directive {
    constructor(
        private kbService: KbService
    ) {
        super();

        this.restrict = "EA";
        this.template = Dirs.component("kb-page-title");
        this.transclude = true;
        this.scope = {
            icon: "@",
            label: "@",
            desc: "@",
            error: "@"
        };
        this.replace = true;
        this.link = (scope: any, element, atts) => {

        };
    }
}
